export default __webpack_public_path__ + "static/designer-adam-ec9897b4779c06e523a35eddce47527f.jpg";